import { render, staticRenderFns } from "./ProjectDetailDialog.vue?vue&type=template&id=0caafd4b&scoped=true"
import script from "./ProjectDetailDialog.vue?vue&type=script&lang=js"
export * from "./ProjectDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailDialog.vue?vue&type=style&index=0&id=0caafd4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caafd4b",
  null
  
)

export default component.exports